var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignatured(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_11130_23940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#FFE6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0.200195C18.517 0.200195 23.7998 5.48304 23.7998 12C23.7998 18.517 18.517 23.7998 12 23.7998C5.48304 23.7998 0.200195 18.517 0.200195 12C0.200195 5.48304 5.48304 0.200195 12 0.200195Z",
    stroke: "#FFCBE4",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11130_23940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4007 8.73421L15.2673 10.6009M16.2818 9.57976C16.5286 9.33309 16.6672 8.99851 16.6672 8.64963C16.6673 8.30074 16.5287 7.96613 16.2821 7.7194C16.0354 7.47266 15.7008 7.33403 15.3519 7.33398C15.003 7.33394 14.6684 7.47249 14.4217 7.71916L8.19355 13.9487C8.0852 14.0567 8.00507 14.1897 7.96022 14.336L7.34375 16.367C7.33169 16.4073 7.33078 16.4502 7.34112 16.491C7.35145 16.5319 7.37265 16.5691 7.40246 16.5989C7.43227 16.6287 7.46958 16.6498 7.51043 16.6601C7.55128 16.6703 7.59415 16.6694 7.63449 16.6572L9.66589 16.0412C9.81203 15.9968 9.94503 15.9171 10.0532 15.8093L16.2818 9.57976Z",
    stroke: "#C1005D",
    strokeWidth: 0.933333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_11130_23940",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999911 0 0 0 0 0.633878 0 0 0 0 0.809574 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11130_23940"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11130_23940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.2,
    height: 11.2,
    fill: "white",
    transform: "translate(6.40039 6.40039)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatured);
export default __webpack_public_path__ + "static/media/signatured.03fa894c07b48257a0604f89d0b7b065.svg";
export { ForwardRef as ReactComponent };